import React, { Component } from 'react';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import { apiUrl } from'../Config/Config';
import $ from 'jquery';
import Select from 'react-select';
import { lang } from '../Helpers/lang';
import { PageTitle, CheckAuth } from "../Helpers/SettingHelper";
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const withRouter = WrappedComponent => props => {
	const params = useParams();
	const  navigate = useNavigate();
	// etc... other react-router-dom v6 hooks
  
	return (
	  <WrappedComponent
		{...props}
		params={params}
		navigate ={navigate}
		// etc...
	  />
	);
};

class PluginClone extends Component {	
	constructor(props)
	{
		CheckAuth();
		super(props);    
    const adminID = (typeof props.params.ID === 'undefined') ? '' : props.params.ID;
		this.state = {		
			adminId: adminID,
			userlist: [],
			companylist: [],
			driverlist: [],
		  fontlist:[],
			Loading:false,
      listIds:[],
      tablist:''
		};

    document.title = PageTitle('Plugin Owner Edit');
   
  }
  componentDidMount() {
    this.getListData();
  }
  getListData(postobject=''){
    var qs = require('qs');
    var admin_id = localStorage.getItem("admin_id");
    var loggedas = localStorage.getItem("loggedas");
    var adminId = this.state.adminId;
   
    axios.get(apiUrl+"pluginowner/pluginclonedetail?adminId="+adminId).then(res => {
      if(res.data.status == 'success'){
        this.setState({ userlist : res.data.userlist});
        this.setState({ companylist : res.data.companylist});
        this.setState({ driverlist : res.data.driverlist});
        this.setState({ fontlist : res.data.fontlist});
        // this.setState({ tablist : res.data.tablist});
			}
		}); 
  }
  userlist() {
    var userlist = this.state.userlist;
    if (userlist != "undefined" && userlist != null) {
      if (Object.keys(userlist).length > 0) {
        const userlistDetails = userlist.map(
          (userlist, Index) => {
            let sno = Index+1;
            return (
              <p>{sno}. {lang.Capitalize(userlist.username)} - {userlist.email}</p>
            );
          }
        );
        return userlistDetails;
      }else{
        return (
          <p>No Records</p>
        );
      }
    } else {
      return (
        <p>No Records</p>
      );
    }
  }
  companylist() {
    var companylist = this.state.companylist;
    if (companylist != "undefined" && companylist != null) {
      if (Object.keys(companylist).length > 0) {
        const companylistDetails = companylist.map(
          (companylist, Index) => {
            let sno = Index+1;
            return (
              <p>{sno}. {lang.Capitalize(companylist.username)} - {companylist.email}</p>
            );
          }
        );
        return companylistDetails;
      }else{
        return (
          <p>No Records</p>
        );
      }
    } else {
      return (
        <p>No Records</p>
      );
    }
  }
  driverlist() {
    var driverlist = this.state.driverlist;
    if (driverlist != "undefined" && driverlist != null) {
      if (Object.keys(driverlist).length > 0) {
        const driverlistDetails = driverlist.map(
          (driverlist, Index) => {
            let sno = Index+1;
            return (
              <p>{sno}. {lang.Capitalize(driverlist.username)} - {driverlist.email}</p>
            );
          }
        );
        return driverlistDetails;
      }else{
        return (
          <p>No Records</p>
        );
      }
    } else {
      return (
        <p>No Records</p>
      );
    }
  }
     
  fontlist() {
    var fontlist = this.state.fontlist;
    if (fontlist != "undefined" && fontlist != null) {
      if (Object.keys(fontlist).length > 0) {
        const fontdetails = fontlist.map(
          (fonts, Index) => {
            let sno = Index+1;                 
            return (
              <p>{sno}.{ fonts.tf_name}</p>
            );
          }   
        );
        return fontdetails;
      }else{
        return (
          <p>No Records</p>
        );
      }
    } else {
      return (
        <p>No Records</p>
      );
    }
  }
  tablist() {
    var tablist = this.state.tablist;
    if (tablist != "undefined" && tablist != null) {
      if (Object.keys(tablist).length > 0) {
        const tabdetails = tablist.map(
          (fonts, Index) => {
            let sno = Index+1;                 
            return (
              <p>{sno}.{ fonts.name}</p>
            );
          }   
        );
        return tabdetails;
      }else{
        return (
          <p>No Records</p>
        );
      }
    } else {
      return (
        <p>No Records</p>
      );
    }
  }
 
     
  handleCheckbox = (id) =>{
    var listidArr = [...this.state.listIds];
    const index = listidArr.findIndex(list => list === id);
    if(index > -1) {
      listidArr = [...listidArr.slice(0, index), ...listidArr.slice(index + 1)]
    } else {
      listidArr.push(id);
    }
    this.setState({listIds: listidArr});
  }
    
  handleSubmit = () => {
    this.setState({ Loading: true });
	  const formdata = this.state;
	  var qs = require('qs');
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    };
    var postObject ={
      admin_id: localStorage.getItem('admin_id'),
      preAdminId : formdata.adminId,
      clone_list : formdata.listIds,
    }

	  let formData = new FormData();
    for(let k in postObject) {
      formData.append(k, postObject[k]);
    }
    axios.post(apiUrl+"pluginowner/setplugincopy",formData,config).then(res => {
      if(res.data.status === "success"){
        this.setState({ Loading: false });
        $('.success_message').html('<div class="status_sucess"><h3>Plugin clone successfully</h3></div>');
        setTimeout(function() {
          $('.success_message').html(this.props.navigate('/pluginowner'));
        }.bind(this),3000);
      }else{
        this.setState({ Loading: false });
        $('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
        setTimeout(function() {
          $('.success_message').html('');
        }.bind(this),3000);
      }
    });
  }
  render() {      
    return (
      <div className="wrapper"> 
        <Header />
        <MenuSidebar currentpage="pluginowner"  currentTab="car" />  
    
        <div id="location-error"></div>
        <div className="content">	
          <div className="content-wrapper">
            <div class="content-wrapper-before"></div>
            <div className="form-wrapper leaa-admin-head card">
              <div className="success_message"></div>
              <div className="title">
                  <h4>Plugin Clone</h4>				
              </div>
              <form className="edit"  onSubmit={ e => { this.handleSubmit(this); e.preventDefault(); }}>             
                <div className="row">
                  <p>Choose the module to get clone</p>
                </div>
                <div className="form-row">
                  <div className="form-left"> 
                    <div className="form-group">
                      <input  type="checkbox" value="user" onChange={this.handleCheckbox.bind(this,'user')} />	<label>User List:</label>
                      <div className='pl-5'>
                        {this.userlist()}
                      </div>
                    </div>
                     
                    
                    <div className="form-group">
                      <input  type="checkbox" value="driver" onChange={this.handleCheckbox.bind(this,'driver')} />	<label>Driver List:</label>
                      <div className='pl-5'>
                        {this.driverlist()}
                      </div>
                    </div>
                    {/* <div className="form-group">

                      <input  type="checkbox" value="font" onChange={this.handleCheckbox.bind(this,'tab')} />	<label>Tabs List:</label>
                      <div className='pl-5'>
                        {this.tablist()}
                      </div>
                    </div> */}

                  </div>
                  <div className="form-right"> 
                    
                     
                    <div className="form-group">
                      <input  type="checkbox" value="company" onChange={this.handleCheckbox.bind(this,'company')} />	<label>Company List:</label>
                      <div className='pl-5'>
                        {this.companylist()}
                      </div>
                    </div> 
                    <div className="form-group">
                      <input  type="checkbox" value="font" onChange={this.handleCheckbox.bind(this,'font')} />	<label>Font List:</label>
                      <div className='pl-5'>
                        {this.fontlist()}
                      </div>
                    </div>                   

                  </div>
                </div>	
                {/* ----------------- */}
                <div className="btn-group export">	
                  <button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" 
                  disabled={this.state.Loading === true ? true : false}
                  >
                    {" "}
                    {this.state.Loading === true && (
                      <span className="load-data">Loading</span>
                    )}{" "}
                    Clone                                          
                  </button>
              
                </div>
              </form>
            </div>      
          </div>	
        </div>
      </div>
    );
  }
}

export default  withRouter(PluginClone);